module.exports = __webpack_public_path__ + "static/media/americanexpressLight.797e58c2.svg";